import { Mail, MessageCircle, Phone } from 'lucide-react'
import {
  SUPPORT_EMAIL,
  SUPPORT_PHONE_DISPLAY,
  SUPPORT_PHONE_E164,
} from '@constants/pricingPlans'

const WHATSAPP_URL = `https://wa.me/${SUPPORT_PHONE_E164.replace('+', '')}`

const contactButtonClass =
  'inline-flex w-full items-center justify-center gap-2.5 rounded-xl bg-primary-600 px-5 py-3.5 text-sm font-semibold text-white shadow-sm transition hover:bg-primary-700 no-underline md:flex-1'

const contactIconClass = 'h-5 w-5 shrink-0 text-white'

interface PricingContactActionsProps {
  readonly title?: string
}

export function PricingContactActions({ title = 'Entre em contacto connosco' }: PricingContactActionsProps) {
  return (
    <div className="w-full max-w-4xl">
      <h2 className="mb-5 text-center text-xl font-bold text-secondary-900 sm:text-2xl">{title}</h2>
      <div className="flex flex-col gap-3 md:flex-row md:items-stretch md:justify-center md:gap-4">
        <a href={`tel:${SUPPORT_PHONE_E164}`} className={contactButtonClass}>
          <Phone className={contactIconClass} aria-hidden strokeWidth={2} />
          Ligue-nos já
        </a>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={contactButtonClass}
        >
          <MessageCircle className={contactIconClass} aria-hidden strokeWidth={2} />
          Falar com um especialista
        </a>
        <a href={`mailto:${SUPPORT_EMAIL}`} className={contactButtonClass}>
          <Mail className={contactIconClass} aria-hidden strokeWidth={2} />
          Envie-nos um email
        </a>
      </div>
      <p className="mt-4 text-center text-xs text-secondary-500">
        {SUPPORT_PHONE_DISPLAY} · {SUPPORT_EMAIL}
      </p>
    </div>
  )
}
